import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

interface UseStylesProps {
  fromMd?: boolean;
}

export const useStyles = ({ fromMd }: UseStylesProps) =>
  ({
    downloadMonitoringContent: {
      display: "flex",
      flexDirection: fromMd ? "row" : "column",
      alignItems: "stretch",
      width: "100%",
      gap: fromMd ? "24px" : "16px"
    },

    historyInfoItem: {
      display: "flex",
      justifyContent: "space-between",
      borderLeft: `1px solid ${colors?.gray200}`
    },

    historyItemIconStyle: {
      width: "16px",
      height: "16px",
      marginRight: "6px",
      marginTop: "8px"
    },

    infoTitleDiv: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      marginBottom: "4px"
    },

    titleWithIconBlock: {
      display: "flex",
      marginLeft: "16px",
      alignItems: "flex-start"
    },

    historyEmptyStatePaper: {
      marginTop: "16px",
      minHeight: "220px",
      borderRadius: "8px",
      display: "flex",
      flexDirection: "column",
      flex: "1",
      justifyContent: "center",
      alignItems: "center"
    },

    containerStyle: {
      flex: fromMd ? "1 1 0" : undefined,
      width: fromMd ? undefined : "100%",
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      gap: "12px"
    }
  }) as CSSObject;
